(function () {
  'use strict';

  /* ══════════════════════════════════════════
     1. SCROLL REVEAL  (.s-reveal → .s-in)
  ══════════════════════════════════════════ */
  function initReveal() {
    var els = document.querySelectorAll('.s-reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('s-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.10, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ══════════════════════════════════════════
     2. NUMBER COUNTER  (.s-count[data-target])
  ══════════════════════════════════════════ */
  function initCounters() {
    var els = document.querySelectorAll('.s-count');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCount(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function animateCount(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    var target = parseFloat(el.dataset.target) || 0;
    var start  = el.dataset.start !== undefined ? parseFloat(el.dataset.start) : 0;
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';
    var isFloat = !Number.isInteger(target);
    /* If start > target we count DOWN (dramatic effect) */
    var from = start;
    var to   = target;
    var dur  = start > target ? 2200 : 1500;
    var t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      /* Ease out expo for countdown — fast then slow landing */
      var ease = start > target
        ? 1 - Math.pow(1 - p, 4)
        : 1 - Math.pow(1 - p, 3);
      var current = from + (to - from) * ease;
      el.textContent = prefix + (isFloat ? current.toFixed(1) : Math.round(current)) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    /* rAF can be throttled to a halt (background tab, low power) — land exactly */
    setTimeout(function () {
      el.textContent = prefix + (isFloat ? to.toFixed(1) : Math.round(to)) + suffix;
    }, dur + 600);
  }

  /* ══════════════════════════════════════════
     4. HERO PARALLAX + CONTENT SCROLL FADE
  ══════════════════════════════════════════ */
  function initHeroParallax() {
    var media   = document.querySelector('.solaya-hero__media');
    var content = document.querySelector('.solaya-hero__content');
    if (!media) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* On mobile the media is in-flow (position:relative), not absolute —
       translateY would create a black gap above the image. Disable. */
    if (window.matchMedia('(max-width: 768px)').matches) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrolled = window.scrollY;

          /* Product image — parallax drift réduit pour éviter de découvrir le fond noir */
          media.style.transform = 'translateY(' + (scrolled * 0.12) + 'px)';

          /* Hero text content — fade très doux, commence tard, reste lisible */
          if (content) {
            var fadeStart = 220;
            var fadeEnd   = 600;
            var progress  = Math.max(0, Math.min(1, (scrolled - fadeStart) / (fadeEnd - fadeStart)));
            content.style.opacity   = 1 - progress * 0.55;
            content.style.transform = 'translateY(' + (progress * -16) + 'px)';
          }

          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ══════════════════════════════════════════
     5. MAGNETIC CTA BUTTONS
  ══════════════════════════════════════════ */
  function initMagneticButtons() {
    if (window.matchMedia('(hover: none)').matches) return;

    var btns = document.querySelectorAll(
      '.solaya-product-focus__cta, .solaya-final-cta__cta, .solaya-hero__cta-wrap a, .solaya-cinematic__cta, .solaya-pdp-hero__cta-primary, .solaya-pdp-roi__cta, .solaya-pdp-unboxing__box-cta'
    );

    btns.forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18;
        var y = (e.clientY - r.top - r.height / 2) * 0.18;
        btn.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
        btn.style.transition = 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        setTimeout(function () { btn.style.transition = ''; }, 500);
      });
    });
  }

  /* ══════════════════════════════════════════
     6. PRODUCT GLOW PULSE (on section enter)
  ══════════════════════════════════════════ */
  function initGlowPulse() {
    var section = document.querySelector('.solaya-product-focus');
    if (!section) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          section.classList.add('s-glow-active');
          io.unobserve(section);
        }
      });
    }, { threshold: 0.3 });
    io.observe(section);
  }

  /* ══════════════════════════════════════════
     7. STICKY ATC — appears after hero exits
  ══════════════════════════════════════════ */
  function initStickyATC() {
    var satc = document.getElementById('solaya-satc');
    if (!satc) return;
    // Supporte la homepage (.solaya-hero) et la page produit (.solaya-pdp-hero__panel ou section entière)
    var hero = document.querySelector('.solaya-hero') || document.querySelector('.solaya-pdp-hero__panel') || document.querySelector('.solaya-pdp-hero');
    if (!hero) return;
    var heroOut = false, footerIn = false;
    function updateSatc() {
      var show = heroOut && !footerIn;
      satc.classList.toggle('solaya-satc--visible', show);
      satc.setAttribute('aria-hidden', String(!show));
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { heroOut = !e.isIntersecting; updateSatc(); });
    }, { threshold: 0.1 });
    io.observe(hero);
    var footer = document.querySelector('.solaya-footer, footer');
    if (footer) {
      var ioF = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { footerIn = e.isIntersecting; updateSatc(); });
      }, { threshold: 0.05 });
      ioF.observe(footer);
    }
  }

  /* ══════════════════════════════════════════
     8. SCROLL PROGRESS BAR
  ══════════════════════════════════════════ */
  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.style.cssText = [
      'position:fixed',
      'top:0',
      'left:0',
      'height:1px',
      'width:0',
      'background:rgba(200,149,108,0.65)',
      'z-index:99998',
      'pointer-events:none',
      'transition:width 0.08s linear'
    ].join(';');
    document.body.appendChild(bar);
    window.addEventListener('scroll', function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      bar.style.width = pct + '%';
    }, { passive: true });
  }

  /* ══════════════════════════════════════════
     8. MARQUEE PAUSE ON HOVER (all tracks)
  ══════════════════════════════════════════ */
  function initMarquee() {
    var container = document.querySelector('.solaya-marquee');
    if (!container) return;
    var tracks = container.querySelectorAll('.solaya-marquee__track');
    container.addEventListener('mouseenter', function () {
      tracks.forEach(function (t) { t.style.animationPlayState = 'paused'; });
    });
    container.addEventListener('mouseleave', function () {
      tracks.forEach(function (t) { t.style.animationPlayState = 'running'; });
    });
  }

  /* ══════════════════════════════════════════
     9. CURSOR AMBIENT GLOW
  ══════════════════════════════════════════ */
  function initCursorAmbient() {
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var glow = document.createElement('div');
    glow.setAttribute('aria-hidden', 'true');
    glow.style.cssText = [
      'position:fixed',
      'top:0',
      'left:0',
      'width:640px',
      'height:640px',
      'border-radius:50%',
      'background:radial-gradient(circle,rgba(200,149,108,0.055) 0%,transparent 68%)',
      'pointer-events:none',
      'z-index:0',
      'opacity:0',
      'will-change:transform,opacity',
      'transition:opacity 0.6s ease'
    ].join(';');
    document.body.appendChild(glow);

    var mouseX = 0, mouseY = 0;
    var curX   = 0, curY   = 0;
    var visible = false;

    document.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (!visible) {
        glow.style.opacity = '1';
        visible = true;
      }
    });

    document.addEventListener('mouseleave', function () {
      glow.style.opacity = '0';
      visible = false;
    });

    var lastX, lastY;
    (function loop() {
      if (!document.hidden) {
        curX += (mouseX - curX) * 0.07;
        curY += (mouseY - curY) * 0.07;
        var rX = Math.round(curX * 10) / 10;
        var rY = Math.round(curY * 10) / 10;
        if (rX !== lastX || rY !== lastY) {
          glow.style.transform = 'translate3d(' + (rX - 320) + 'px,' + (rY - 320) + 'px,0)';
          lastX = rX;
          lastY = rY;
        }
      }
      requestAnimationFrame(loop);
    })();
  }

  /* ══════════════════════════════════════════
     11. PDP GALLERY — thumbnail switching + 3D tilt
  ══════════════════════════════════════════ */
  function initPDPGallery() {
    var thumbs    = Array.prototype.slice.call(document.querySelectorAll('.solaya-pdp-hero__thumb'));
    var mainImage = document.getElementById('pdp-main-image');
    if (!thumbs.length || !mainImage) return;

    var current = 0;
    var swapToken = 0;

    /* Warm the full-size set once the browser is idle — the first switch
       must come from cache, never from the network (visible pop-in). */
    function warmGallery() {
      if (navigator.connection && navigator.connection.saveData) return;
      thumbs.forEach(function (t) {
        var s = t.getAttribute('data-src');
        if (s) { var im = new Image(); im.src = s; }
      });
    }
    function scheduleWarm() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(warmGallery, { timeout: 5000 });
      else setTimeout(warmGallery, 1500);
    }
    if (document.readyState === 'complete') scheduleWarm();
    else window.addEventListener('load', scheduleWarm, { once: true });

    function setActive(idx) {
      idx = (idx % thumbs.length + thumbs.length) % thumbs.length; /* wrap-around */
      if (idx === current) return;
      var thumb  = thumbs[idx];
      var newSrc = thumb.getAttribute('data-src');
      var newAlt = thumb.getAttribute('data-alt') || '';
      if (!newSrc) return;
      current = idx;
      var token = ++swapToken;

      /* LED glow + reflection only live on the product shot (g0).
         data-flat-gallery = every slide is an opaque marketing visual,
         so the cut-out treatment never applies (PrecisionCore). */
      var mainWrap = document.getElementById('pdp-gallery-main');
      if (mainWrap && !mainWrap.hasAttribute('data-flat-gallery')) {
        mainWrap.classList.toggle('is-product-shot', idx === 0);
      }

      /* Load first, swap second — the frame must never pop in half-loaded.
         Cached image → swaps right after the short fade; cold image → swaps
         the instant it arrives. Rapid clicks: only the last one lands. */
      var fadeDone = false, imgReady = false;
      function trySwap() {
        if (!fadeDone || !imgReady || token !== swapToken) return;
        mainImage.src = newSrc;
        mainImage.alt = newAlt;
        mainImage.style.opacity = '1';
      }
      mainImage.style.transition = 'opacity 0.16s ease, transform 0.12s ease';
      mainImage.style.opacity = '0';
      setTimeout(function () { fadeDone = true; trySwap(); }, 170);
      var loader = new Image();
      loader.onload = loader.onerror = function () { imgReady = true; trySwap(); };
      loader.src = newSrc;
      if (loader.complete) { imgReady = true; }

      /* Update active thumb + keep it in view in the scrollable row */
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      try { thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { setActive(i); });
    });

    /* Arrows */
    var prevBtn = document.getElementById('pdp-gallery-prev');
    var nextBtn = document.getElementById('pdp-gallery-next');
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); setActive(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); setActive(current + 1); });

    /* Swipe on the main image (touch devices) */
    var swipeWrap = document.getElementById('pdp-gallery-main');
    if (swipeWrap) {
      var sx = 0, sy = 0, swiping = false;
      swipeWrap.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });
      swipeWrap.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          setActive(dx < 0 ? current + 1 : current - 1);
        }
      }, { passive: true });
    }

    /* 3D tilt on PDP gallery main wrap */
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var wrap = document.getElementById('pdp-gallery-main');
    if (!wrap || !mainImage) return;

    mainImage.style.transition = 'opacity 0.35s ease, transform 0.12s ease';

    wrap.addEventListener('mousemove', function (e) {
      var r  = wrap.getBoundingClientRect();
      var dx = (e.clientX - r.left  - r.width  / 2) / (r.width  / 2);
      var dy = (e.clientY - r.top   - r.height / 2) / (r.height / 2);
      var rotY =  dx * 7;
      var rotX = -dy * 5;
      mainImage.style.transform = 'perspective(900px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) scale3d(1.03,1.03,1)';
    });

    wrap.addEventListener('mouseleave', function () {
      mainImage.style.transition = 'opacity 0.35s ease, transform 0.65s cubic-bezier(0.25,0.46,0.45,0.94)';
      mainImage.style.transform  = 'perspective(900px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)';
      setTimeout(function () { mainImage.style.transition = 'opacity 0.35s ease, transform 0.12s ease'; }, 650);
    });
  }

  /* ══════════════════════════════════════════
     12. PDP NAV — sticky reveal + active states
  ══════════════════════════════════════════ */
  function initPDPNav() {
    var nav = document.getElementById('pdp-nav');
    if (!nav) return;

    /* Reveal nav when hero exits viewport */
    var hero = document.getElementById('pdp-hero');
    if (hero) {
      var heroObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          nav.classList.toggle('is-visible', !e.isIntersecting);
        });
      }, { threshold: 0.05 });
      heroObs.observe(hero);
    }

    /* Active link via IntersectionObserver on target sections */
    var links = nav.querySelectorAll('.solaya-pdp-nav__link[data-nav-target]');
    if (!links.length) return;

    var targets = [];
    links.forEach(function (link) {
      var el = document.getElementById(link.dataset.navTarget);
      if (el) targets.push({ link: link, el: el });
    });

    if (!targets.length) return;

    var sectionObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          targets.forEach(function (t) { t.link.classList.remove('is-active'); });
          var match = targets.find(function (t) { return t.el === entry.target; });
          if (match) match.link.classList.add('is-active');
        }
      });
    }, { threshold: 0.30 });

    targets.forEach(function (t) { sectionObs.observe(t.el); });

    /* Smooth scroll on click — drift-proof.
       Lazy-loaded images shift layout while the smooth scroll runs on this
       long page, so the position computed at click time goes stale. After the
       animation settles we re-measure the target and correct until stable. */
    var navScrollTimer = null;
    function scrollToNavTarget(el) {
      var navH = nav.offsetHeight || 44;
      function wanted() {
        return Math.max(0, el.getBoundingClientRect().top + window.scrollY - navH - 8);
      }
      if (navScrollTimer) { clearInterval(navScrollTimer); navScrollTimer = null; }
      window.scrollTo({ top: wanted(), behavior: 'smooth' });

      var lastY = -1, stable = 0, corrections = 0;
      navScrollTimer = setInterval(function () {
        if (Math.abs(window.scrollY - lastY) < 2) { stable++; } else { stable = 0; lastY = window.scrollY; }
        if (stable >= 2) { /* animation settled (~260ms without movement) */
          var want = wanted();
          if (Math.abs(window.scrollY - want) > 32 && corrections < 4) {
            corrections++;
            stable = 0;
            window.scrollTo({ top: want, behavior: 'smooth' });
          } else {
            clearInterval(navScrollTimer);
            navScrollTimer = null;
          }
        }
      }, 130);
      /* safety: never run forever */
      setTimeout(function () {
        if (navScrollTimer) { clearInterval(navScrollTimer); navScrollTimer = null; }
      }, 7000);
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var el = document.getElementById(link.dataset.navTarget);
        if (!el) return;
        scrollToNavTarget(el);
      });
    });
  }

  /* ══════════════════════════════════════════
     13. PDP STICKY BUY BAR — desktop
  ══════════════════════════════════════════ */
  function initPDPStickyBuy() {
    var stickyBar = document.getElementById('pdp-sticky-buy');
    var buyPanel  = document.getElementById('pdp-buy-panel');
    if (!stickyBar || !buyPanel) return;
    if (window.matchMedia('(max-width: 900px)').matches) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var visible = !e.isIntersecting;
        stickyBar.classList.toggle('is-visible', visible);
        stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }, { threshold: 0.05 });

    obs.observe(buyPanel);
  }

  /* ══════════════════════════════════════════
     14. PDP FEATURES PARALLAX — subtle depth on scroll
  ══════════════════════════════════════════ */
  function initPDPParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(max-width: 900px)').matches) return;

    var images = document.querySelectorAll('.solaya-pdp-feature__image[data-parallax]');
    if (!images.length) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollY = window.scrollY;
          images.forEach(function (img) {
            var parent = img.closest('.solaya-pdp-feature__media');
            if (!parent) return;
            var rect   = parent.getBoundingClientRect();
            var center = rect.top + rect.height / 2;
            var vh     = window.innerHeight;
            /* Only apply when the element is near the viewport */
            if (rect.bottom < -100 || rect.top > vh + 100) return;
            var offset = (center - vh / 2) * 0.10;
            img.style.transform = 'translateY(' + offset + 'px) scale(1.06)';
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ══════════════════════════════════════════
     10. PRODUCT IMAGE 3D TILT
  ══════════════════════════════════════════ */
  function initProductTilt() {
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var media = document.querySelector('.solaya-product-focus__media');
    var img   = document.querySelector('.solaya-product-focus__image');
    if (!media || !img) return;

    img.style.transition = 'transform 0.12s ease';

    media.addEventListener('mousemove', function (e) {
      var r  = media.getBoundingClientRect();
      var dx = (e.clientX - r.left  - r.width  / 2) / (r.width  / 2);
      var dy = (e.clientY - r.top   - r.height / 2) / (r.height / 2);
      var rotY =  dx * 7;
      var rotX = -dy * 5;
      img.style.transform = 'perspective(900px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) scale3d(1.03,1.03,1)';
    });

    media.addEventListener('mouseleave', function () {
      img.style.transition = 'transform 0.65s cubic-bezier(0.25,0.46,0.45,0.94)';
      img.style.transform  = 'perspective(900px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)';
      setTimeout(function () { img.style.transition = 'transform 0.12s ease'; }, 650);
    });
  }

  /* ══════════════════════════════════════════
     NEWSLETTER POPUP
  ══════════════════════════════════════════ */
  function initNewsletterPopup() {
    var backdrop   = document.getElementById('solaya-popup-backdrop');
    var popup      = document.getElementById('solaya-popup');
    if (!backdrop || !popup) return;

    var POPUP_KEY    = 'solaya_popup_ts';
    var closeBtn     = document.getElementById('solaya-popup-close');
    var emailInput   = document.getElementById('solaya-popup-email');
    var submitBtn    = document.getElementById('solaya-popup-submit');
    var submitLabel  = document.getElementById('solaya-popup-submit-label');
    var errorEl      = document.getElementById('solaya-popup-error');
    var formInner    = document.getElementById('solaya-popup-form-inner');
    var successEl    = document.getElementById('solaya-popup-success');
    var codeBlock    = document.getElementById('solaya-popup-code-block');
    var copyLabel    = document.getElementById('solaya-popup-copy-label');

    var isOpen             = false;
    var triggered          = false;
    var mobileScrollFired  = false;

    /* ── Guard: pages où le popup est contre-productif ── */
    var path = window.location.pathname.replace(/\/$/, ''); // strip trailing slash
    if (
      path === '/cart' ||
      path.indexOf('/checkout') === 0 ||
      path === '/account' ||
      path.indexOf('/account/') === 0
    ) return;

    /* ── Guard: already suppressed via localStorage ── */
    var stored = localStorage.getItem(POPUP_KEY);
    if (stored && Date.now() < parseInt(stored, 10)) return;

    /* ── Show ── */
    function showPopup() {
      if (isOpen || triggered) return;
      triggered = true;
      document.body.style.overflow = 'hidden'; // lock background scroll
      backdrop.classList.add('is-open');
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      isOpen = true;
      setTimeout(function () { if (emailInput) emailInput.focus(); }, 120);
      window.removeEventListener('scroll', onMobileScroll);
    }

    /* ── Hide ── */
    function hidePopup() {
      document.body.style.overflow = ''; // restore scroll
      backdrop.classList.remove('is-open');
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      isOpen = false;
      /* Suppress for 30 days after manual close */
      localStorage.setItem(POPUP_KEY, Date.now() + 30 * 24 * 60 * 60 * 1000);
    }

    /* ── Trigger 1 : 18-second delay ── */
    setTimeout(showPopup, 18000);

    /* ── Trigger 2 : exit-intent (desktop only) ── */
    if (!window.matchMedia('(max-width: 768px)').matches) {
      document.addEventListener('mouseleave', function onExitIntent(e) {
        if (e.clientY < 5) {
          showPopup();
          document.removeEventListener('mouseleave', onExitIntent);
        }
      });
    }

    /* ── Trigger 3 : 40% scroll (mobile only) ── */
    function onMobileScroll() {
      if (mobileScrollFired) return;
      var total = document.body.scrollHeight - window.innerHeight;
      if (total > 0 && window.scrollY / total > 0.40) {
        mobileScrollFired = true;
        showPopup();
      }
    }
    if (window.matchMedia('(max-width: 768px)').matches) {
      window.addEventListener('scroll', onMobileScroll, { passive: true });
    }

    /* ── Close: button, backdrop, Escape ── */
    closeBtn.addEventListener('click', hidePopup);
    backdrop.addEventListener('click', hidePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) hidePopup();
    });

    /* ── Focus trap ── */
    popup.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(
        popup.querySelectorAll('button:not([disabled]), input, [tabindex="0"]')
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });

    /* ── Form validation & AJAX submit ── */
    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.classList.add('is-visible');
    }
    function clearError() {
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }
    function showSuccess() {
      formInner.classList.add('is-hidden');
      successEl.classList.add('is-active');
      /* Suppress for 60 days after subscription */
      localStorage.setItem(POPUP_KEY, Date.now() + 60 * 24 * 60 * 60 * 1000);
    }

    var POPUP_I18N = (window.SOLAYA_I18N && window.SOLAYA_I18N.popup) || {};

    submitBtn.addEventListener('click', function () {
      clearError();
      var email = emailInput.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showError(POPUP_I18N.email_invalid || 'Veuillez saisir une adresse e-mail valide.');
        emailInput.focus();
        return;
      }

      submitBtn.disabled = true;
      submitLabel.textContent = POPUP_I18N.submitting || 'Inscription\u2026';

      var params = new URLSearchParams();
      params.append('form_type', 'customer');
      params.append('utf8', '\u2713');
      params.append('contact[email]', email);
      params.append('contact[tags]', 'newsletter,popup-inscription');

      fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: params.toString()
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        /* status 422 (already subscribed) or 200 — show success either way */
        showSuccess();
      })
      .catch(function () {
        /* Network error — graceful degradation: show success */
        showSuccess();
      });
    });

    /* Enter key on email input triggers submit */
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submitBtn.click();
    });

    /* ── Copy promo code ── */
    function copyCode() {
      var code = POPUP_I18N.code_value || 'BIENVENUE10';
      var copiedTxt = POPUP_I18N.code_copied || 'Copi\u00e9\u00a0!';
      var copyTxt   = POPUP_I18N.code_copy   || 'Copier';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          copyLabel.textContent = copiedTxt;
          setTimeout(function () { copyLabel.textContent = copyTxt; }, 2200);
        }).catch(fallbackCopy.bind(null, code));
      } else {
        fallbackCopy(code);
      }
    }

    function fallbackCopy(text) {
      var copiedTxt = POPUP_I18N.code_copied || 'Copi\u00e9\u00a0!';
      var copyTxt   = POPUP_I18N.code_copy   || 'Copier';
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* silent */ }
      document.body.removeChild(ta);
      copyLabel.textContent = copiedTxt;
      setTimeout(function () { copyLabel.textContent = copyTxt; }, 2200);
    }

    codeBlock.addEventListener('click', copyCode);
    codeBlock.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copyCode(); }
    });
  }

  /* ══════════════════════════════════════════
     15. SECTION SCANNER — gold horizontal sweep
         Triggered on first reveal of [data-scanner]
  ══════════════════════════════════════════ */
  function initSectionScanner() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sections = document.querySelectorAll('[data-scanner]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      /* Inject scanner line if not present */
      if (!section.querySelector('.solaya-scanner-line')) {
        var line = document.createElement('span');
        line.className = 'solaya-scanner-line';
        line.setAttribute('aria-hidden', 'true');
        line.style.cssText = [
          'position:absolute',
          'top:0',
          'left:0',
          'width:100%',
          'height:1px',
          'background:linear-gradient(90deg,transparent 0%,rgba(232,184,112,0) 8%,rgba(232,184,112,0.9) 50%,rgba(232,184,112,0) 92%,transparent 100%)',
          'box-shadow:0 0 12px rgba(232,184,112,0.55)',
          'pointer-events:none',
          'z-index:6',
          'opacity:0',
          'transform:translateY(0)',
          'will-change:transform,opacity'
        ].join(';');
        /* Make sure parent is positioned */
        var cs = window.getComputedStyle(section);
        if (cs.position === 'static') section.style.position = 'relative';
        section.appendChild(line);
      }
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var line = e.target.querySelector('.solaya-scanner-line');
        if (!line) { io.unobserve(e.target); return; }

        var h = e.target.getBoundingClientRect().height;
        line.style.transition = 'opacity 0.30s ease';
        line.style.opacity = '1';
        /* Animate via Web Animations API for clean GPU sweep */
        line.animate(
          [
            { transform: 'translateY(0px)', opacity: 0 },
            { transform: 'translateY(20px)', opacity: 1, offset: 0.10 },
            { transform: 'translateY(' + (h - 6) + 'px)', opacity: 1, offset: 0.92 },
            { transform: 'translateY(' + h + 'px)', opacity: 0 }
          ],
          { duration: 1600, easing: 'cubic-bezier(0.65, 0.05, 0.36, 1)', fill: 'forwards' }
        );

        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    sections.forEach(function (s) { io.observe(s); });
  }

  /* ══════════════════════════════════════════
     16. GOLD CONFETTI — burst on [data-confetti] click
  ══════════════════════════════════════════ */
  function initGoldConfetti() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var triggers = document.querySelectorAll('[data-confetti="gold"]');
    if (!triggers.length) return;

    var GOLDS = ['#C8956C', '#E8B870', '#F0C878', '#FFFFFF'];

    function burst(originX, originY) {
      var canvas = document.createElement('canvas');
      canvas.style.cssText = [
        'position:fixed',
        'top:0',
        'left:0',
        'width:100vw',
        'height:100vh',
        'pointer-events:none',
        'z-index:99999'
      ].join(';');
      canvas.width  = window.innerWidth  * (window.devicePixelRatio || 1);
      canvas.height = window.innerHeight * (window.devicePixelRatio || 1);
      document.body.appendChild(canvas);

      var ctx = canvas.getContext('2d');
      ctx.scale(window.devicePixelRatio || 1, window.devicePixelRatio || 1);

      var particles = [];
      var COUNT = 70;
      for (var i = 0; i < COUNT; i++) {
        var angle = (Math.PI * 2) * (i / COUNT) + (Math.random() - 0.5) * 0.6;
        var speed = 4 + Math.random() * 7;
        particles.push({
          x: originX,
          y: originY,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - 2,
          size: 2 + Math.random() * 3,
          rot: Math.random() * Math.PI * 2,
          vr: (Math.random() - 0.5) * 0.3,
          color: GOLDS[(Math.random() * GOLDS.length) | 0],
          life: 1,
          decay: 0.012 + Math.random() * 0.012
        });
      }

      var gravity = 0.18;
      var startTs = null;

      function frame(ts) {
        if (!startTs) startTs = ts;
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        var alive = false;
        for (var i = 0; i < particles.length; i++) {
          var p = particles[i];
          if (p.life <= 0) continue;
          alive = true;
          p.x   += p.vx;
          p.y   += p.vy;
          p.vy  += gravity;
          p.vx *= 0.99;
          p.rot += p.vr;
          p.life -= p.decay;

          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.globalAlpha = Math.max(0, p.life);
          ctx.fillStyle = p.color;
          /* Rectangle = paillette dorée */
          ctx.fillRect(-p.size, -p.size * 0.35, p.size * 2, p.size * 0.7);
          ctx.restore();
        }
        if (alive && (ts - startTs) < 2400) {
          requestAnimationFrame(frame);
        } else {
          canvas.remove();
        }
      }
      requestAnimationFrame(frame);
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var r = btn.getBoundingClientRect();
        burst(r.left + r.width / 2, r.top + r.height / 2);
      });
    });
  }

  /* ══════════════════════════════════════════
     INIT
  ══════════════════════════════════════════ */
  /* ══════════════════════════════════════════
     MASKED HEADLINE REVEALS
     Big serif titles inside .s-reveal blocks get split on <br> into
     masked lines that slide up with a stagger once the block reveals.
  ══════════════════════════════════════════ */
  function initSplitHeadlines() {
    var els = document.querySelectorAll('.s-reveal h1, .s-reveal h2, .s-reveal h3, h1.s-reveal, h2.s-reveal, h3.s-reveal');
    els.forEach(function (h) {
      if (h.dataset.split) return;
      if (parseFloat(getComputedStyle(h).fontSize) < 28) return;
      var container = h.closest('.s-reveal');
      if (!container || container.classList.contains('s-in')) return;

      var groups = [[]];
      Array.prototype.slice.call(h.childNodes).forEach(function (n) {
        if (n.nodeName === 'BR') { groups.push([]); }
        else { groups[groups.length - 1].push(n); }
      });
      if (!groups[0].length) return;

      h.dataset.split = '1';
      h.textContent = '';
      groups.forEach(function (g, i) {
        if (!g.length) return;
        var line  = document.createElement('span');
        line.className = 'x-line';
        var inner = document.createElement('span');
        inner.className = 'x-line-inner';
        inner.style.transitionDelay = (0.08 + i * 0.14) + 's';
        g.forEach(function (n) { inner.appendChild(n); });
        line.appendChild(inner);
        h.appendChild(line);
      });
    });
  }

  /* ══════════════════════════════════════════
     VIDEO BLOCKS — film & UGC
     Muted autoplay while visible, paused off-screen. Sound is a user
     choice; if autoplay is blocked (iOS Low Power…), a play button
     appears over the poster instead of a dead frame.
  ══════════════════════════════════════════ */
  function initVideoBlocks() {
    var vids = document.querySelectorAll('video[data-solaya-video]');
    if (!vids.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Only one audible video at a time — mute the rest and sync their buttons */
    function muteOthers(current) {
      vids.forEach(function (o) {
        if (o === current || o.muted) return;
        o.muted = true;
        var w = o.closest('[data-video-wrap]') || o.parentElement;
        var b = w.querySelector('[data-video-sound]');
        if (b) {
          b.classList.remove('is-on');
          b.setAttribute('aria-pressed', 'false');
        }
      });
    }

    vids.forEach(function (v) {
      var wrap     = v.closest('[data-video-wrap]') || v.parentElement;
      var soundBtn = wrap.querySelector('[data-video-sound]');
      var playBtn  = wrap.querySelector('[data-video-play]');

      function showPlay() { if (playBtn) playBtn.classList.add('is-visible'); }
      function hidePlay() { if (playBtn) playBtn.classList.remove('is-visible'); }

      function tryPlay() {
        if (reduced) { showPlay(); return; }
        var p = v.play();
        if (p && p.then) p.then(hidePlay).catch(showPlay);
      }
      v.solayaTryPlay = tryPlay;

      function pauseByUs() {
        if (v.paused) return;
        v.dataset.pausedByUs = '1';
        v.pause();
      }
      v.solayaPause = pauseByUs;

      /* Browser force-paused it (iOS Low Power, resource saver…) while
         on screen → offer a play button instead of a frozen frame. */
      v.addEventListener('pause', function () {
        if (v.dataset.pausedByUs) { delete v.dataset.pausedByUs; return; }
        var r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) showPlay();
      });

      function updateSound() {
        if (!soundBtn) return;
        soundBtn.classList.toggle('is-on', !v.muted);
        soundBtn.setAttribute('aria-pressed', String(!v.muted));
      }

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          v.muted = false;
          muteOthers(v);
          updateSound();
          v.play();
          playBtn.classList.remove('is-visible');
        });
      }

      if (soundBtn) {
        soundBtn.addEventListener('click', function () {
          v.muted = !v.muted;
          if (!v.muted) muteOthers(v);
          if (v.paused) v.play();
          updateSound();
        });
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { tryPlay(); }
            else { pauseByUs(); }
          });
        }, { threshold: 0.25 });
        io.observe(v);
      } else {
        tryPlay();
      }
    });
  }

  /* ══════════════════════════════════════════
     REVEAL SAFETY NET
     IntersectionObserver callbacks can be throttled or dropped entirely
     (iOS Low Power Mode, background tabs, some in-app webviews). Content
     must never stay invisible because an observer went quiet: this sweep
     force-reveals anything at or above the viewport until nothing is left.
  ══════════════════════════════════════════ */
  function initRevealFallback() {
    var ticking = false;

    function sweep() {
      ticking = false;
      var limit = window.innerHeight * 1.15;
      var pending = false;

      document.querySelectorAll('.s-reveal:not(.s-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < limit) { el.classList.add('s-in'); }
        else { pending = true; }
      });

      var vs = document.querySelector('[data-vstack]:not(.is-revealed)');
      if (vs) {
        if (vs.getBoundingClientRect().top < limit) { vs.classList.add('is-revealed'); }
        else { pending = true; }
      }

      /* Review score bars + stars (trust section local observer) — same net */
      document.querySelectorAll('.st__bar-track:not(.s-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < limit) { el.classList.add('s-in'); }
        else { pending = true; }
      });
      document.querySelectorAll('.st__star:not(.s-star-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < limit) { el.classList.add('s-star-in'); }
        else { pending = true; }
      });

      /* ROI ledger rows have their own section-local observer — same net */
      document.querySelectorAll('.srs__visite:not(.s-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < limit) { el.classList.add('s-in'); }
        else { pending = true; }
      });

      document.querySelectorAll('.s-count').forEach(function (el) {
        if (el.dataset.counted) return;
        if (el.getBoundingClientRect().top < window.innerHeight * 0.9) { animateCount(el); }
        else { pending = true; }
      });

      /* Videos: keep play state right even if their observer went quiet */
      document.querySelectorAll('video[data-solaya-video]').forEach(function (v) {
        if (!v.solayaTryPlay) return;
        var r = v.getBoundingClientRect();
        var inView = r.bottom > 0 && r.top < window.innerHeight;
        if (inView && v.paused) { v.solayaTryPlay(); }
        else if (!inView && !v.paused) { v.solayaPause(); }
      });

      return pending;
    }

    var timer = setInterval(function () {
      if (!sweep()) { clearInterval(timer); timer = null; }
    }, 900);

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(sweep); }
    }, { passive: true });
  }

  function init() {
    initSplitHeadlines();
    initReveal();
    initCounters();
    initVideoBlocks();
    initRevealFallback();
    initHeroParallax();
    initMagneticButtons();
    initGlowPulse();
    initStickyATC();
    initScrollProgress();
    initMarquee();
    initCursorAmbient();
    initProductTilt();
    initPDPParallax();
    initPDPGallery();
    initPDPNav();
    initPDPStickyBuy();
    initSectionScanner();
    initGoldConfetti();
    initNewsletterPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
